// extracted by mini-css-extract-plugin
export default {"default_layout":"defaultLayout_default_layout__2zX0g","content":"defaultLayout_content__1G0cs"};